import { createElement } from "react";
/**
 * WordPress Depndencies
 */
import { useState } from '@wordpress/element';

/**
 * External Dependencies
 */
import classnames from 'classnames';

/**
 * Internal Depndencies
 */
import FieldHeader from '../field-header';
import BlockOutput from '../field-display-wrapper';
const FieldContent = () => {
  const [isShaking, setIsShaking] = useState(false);
  return createElement("div", {
    className: classnames('renderer-components-field-content', {
      'is-shaking': isShaking
    })
  }, createElement(FieldHeader, null), createElement(BlockOutput, {
    isShaking: isShaking,
    setIsShaking: val => {
      setIsShaking(val);
    }
  }));
};
export default FieldContent;
//# sourceMappingURL=index.js.map